import React, { useEffect } from 'react';
import './zones-page.scss';
import { useSelector, useDispatch } from 'react-redux';
import { loadZoneList } from '../actions';
import { useUpdatePeriod } from '../../../utils/utils';
import { getZoneData } from '../reducer';

import PageHeader from '../../../components/base/PageHeader/PageHeader';
import GridZoneCards from './GridZoneCards';
import Loader from '../../../components/base/Loader/Loader';
import { getSystemData } from '../../System/reducer';
import ModuleUnavailableState from '../../../components/base/ModuleUnavailableState';
import { isMenuUnavailable } from '../../System/serviceAvailability';

export default function ZonesPage() {
  const dispatch = useDispatch();
  const { updatePeriod, serviceAvailability } = useSelector(getSystemData);
  const isModuleUnavailable = isMenuUnavailable(serviceAvailability, 'menu.zones-page');
  const { loadingZoneList, zoneList } = useSelector(getZoneData);

  const loadData = opts => {
    if (isModuleUnavailable) {
      return Promise.resolve([]);
    }

    const p1 = dispatch(loadZoneList()).catch(() => {});
    return Promise.all([p1]);
  };

  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  return (
    <div className="zones-page">
      <div className="zones-page-wrapper">
        <PageHeader header="Список зон">
          <div className="header-loader"><Loader loading={loadingZoneList} /></div>
        </PageHeader>
        {isModuleUnavailable ? <ModuleUnavailableState /> : <GridZoneCards loadData={loadData} zones={zoneList} />}
      </div>
    </div>
  );
}
